import { render, staticRenderFns } from "./testuploaddialog.vue?vue&type=template&id=2f7fa0dc&"
import script from "./testuploaddialog.vue?vue&type=script&lang=js&"
export * from "./testuploaddialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports